module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_5010.eb38aa60.png";